module.exports = __webpack_public_path__ + "static/media/stay-banner2.ec66f7e8.png";